export enum AssetType {
  Image = 1,
  Document = 2
}
import { Injectable } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  createPatchArray(columnName: string, value: any) {
    return [
      {
        "value": value,
        "path": "/" + columnName,
        "op": "replace"
      }
    ]
  }

  isImageAsset(typeId: number): boolean {
    return typeId === AssetType.Image;
  }

  createImageSource(imgUrl: SafeUrl, CreatedBy: string, CreatedDate: string) {
    return [
      {
        "imgUrl": imgUrl,
        "CreatedBy": CreatedBy,
        "CreatedDate": CreatedDate
      }
    ]
  }
}
